var map = {
	"./de/mechaName.png": "lZcR",
	"./en/mechaName.png": "Utlp",
	"./es/mechaName.png": "i9/t",
	"./fr/mechaName.png": "jNv8",
	"./ja/mechaName.png": "th/H",
	"./ko/mechaName.png": "0Zjr",
	"./pt/mechaName.png": "cAxG",
	"./ru/mechaName.png": "bv7x",
	"./tc/mechaName.png": "1Bh5",
	"./th/mechaName.png": "9TGf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2un4";